import { useEffect } from 'react';
import {
  NavigationType,
  useLocation,
  useNavigationType
} from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { navigationHandlerAtom } from '../atoms';

export const useNavigationHandler = () => {
  const type = useNavigationType();
  const location = useLocation();

  const [{ onBack, onForward }, setState] = useRecoilState(
    navigationHandlerAtom
  );

  useEffect(() => {
    if (type === NavigationType.Pop) {
      onBack?.();

      if (onBack) {
        setState((prevState) => ({ ...prevState, onBack: undefined }));
      }
    }

    if (type === NavigationType.Push) {
      onForward?.();

      if (onForward) {
        setState((prevState) => ({ ...prevState, onForward: undefined }));
      }
    }

    // Triggers when the location changes
  }, [location.pathname]);
};
